import { map as _map } from 'lodash';
import memoize from 'memoize-one';

import { Images } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { PaymentScreenTypes, PaymentTypes } from '../../Utils/PaymentTypes';

const {
  DEFAULT,
  PAYMENTREQUEST,
  SUCCESSOFFERGIFT,
  ADDDATAOFFER,
  UPGRADETOOFFER,
  PAYMENTSUCCESSFULLY,
  PAYMENTFAILD,
  DATAADDED,
  OFFERGIFT,
  ADD_PAYMENT_CARD,
  ADD_PAYMENT_CARD_LOADING,
  SETUP_AUTO_BILL,
  SETUP_AUTO_BILL_LOADING,
  SETUP_AUTO_BILL_SUCCESS,
  SETUP_AUTO_BILL_ERROR,
  SETUP_AUTO_TOP_UP,
  SETUP_AUTO_TOP_UP_LOADING,
  SETUP_AUTO_TOP_UP_SUCCESS,
  SETUP_AUTO_TOP_UP_ERROR,
  DEFAULT_ERROR,
  TOP_UP_SOMEONE_ELSE,
  TOP_UP_SOMEONE_ELSE_LOADING,
  TOP_UP_SOMEONE_ELSE_SUCCESS,
  TOP_UP_SOMEONE_ELSE_ERROR,
  TOP_UP_SOMEONE_ELSE_CONTACT_LIST,
  CUSTOM_AMOUNT,
  VOUCHER_INTIIAL_STATE,
  VOUVHER_TOP_UP_LOADING,
  VOUCHER_TOP_UP_SUCCESS,
  VOUCHER_TOP_UP_ERROR,
} = PaymentScreenTypes;

const getCenterViewConfig = (
  title,
  subTitle,
  lottietype,
  lottieID,
  titleID,
  subTitleID,
  titlePlaceHolders,
  subTitlePlaceHolders,
) => {
  return {
    title,
    subTitle,
    lottietype,
    lottieID,
    titleID,
    subTitleID,
    titlePlaceHolders,
    subTitlePlaceHolders,
  };
};

const getHeaderConfig = (
  titleGift,
  mainTitle,
  description,
  mainTitlePlaceHolders,
  descriptionPlaceHolders,
  mainTitleID,
  descriptionID,
) => {
  return {
    titleGift,
    mainTitle,
    description,
    mainTitlePlaceHolders,
    descriptionPlaceHolders,
    mainTitleID,
    descriptionID,
  };
};

const getPaymentBodyConfig = props => {
  const {
    checkObjectHasProperty,
    onSelectWheelValue,
    onPressSaveCard,
    onSelectDefaultCard,
    hiddenFields,
    cardData,
    validations,
    newBalance,
    newExtraOffer,
    currency,
    singleValue,
    value,
    QASubtitle,
    type,
    isAddDataWithGift,
    billPaymentSuccessPlaceholders,
    wheelValues,
    offerValues,
    defaultWheelValue,
    giftIcon,
    wheelSelectorCurrencyAccessibilityLabel,
    wheelSelectorGiftIconAccessibilityLabel,
    wheelSelectorValueAccessibilityLabel,
    paymentDefaultTitleID,
    offerGiftIconID,
    offerGiftTitleID,
    offerGiftSubtitleID,
    paymentSuccessfullyIconID,
    paymentSuccessfullyTitleID,
    paymentSuccessfullySubtitleID,
    paymentRequestIconID,
    paymentRequestSubtitleID,
    upgradeOfferTitleID,
    upgradeOfferSubtitleID,
    autoBillMonth,
    autoBillDay,
    autoTopUpData,
    autoBillDayLimit,
    autoTopUpMonthDaysLimit,
    autoTopUpLessThanAmounts,
    onSelectBillDay,
    onSelectAutoTopUpData,
    autoTopUpSuccessPlaceholders,
    error,
    loadingError,
    onTryAgainPress,
    accounts,
    handleOnPressRecipient,
    recentContacts,
    phoneNumberValidation,
    setIsValidTopupNumber,
    onContactListIconPress,
    phoneNo,
    setPhoneNo,
    hideSaveCardForLater,
    saveForLaterIntialValue,
    shouldShowTempCardName,
    selectedValue,
    onAddOffer,
    selectedTab,
    onSelectTabChange,
    customAmount,
    onChangeCustomAmount,
    withCustomTabAmount,
    customAmountValidation,
    customAmountMaximum,
    voucherAmount,
    isValidTopupNumber,
    isDesktopWeb,
  } = props;

  const isBillingPayment = type === PaymentTypes.BILLING_PAYMENT;
  const isSetupAutoBill = type === PaymentTypes.SETUP_AUTO_BILL;
  const isSetupAutoTopUp = type === PaymentTypes.SETUP_AUTO_TOP_UP;
  const isVoucherTopUp = type === PaymentTypes.VOUCHER_TOP_UP;

  const hasGiftValue = wheelValues && wheelValues.filter(v => v.gift === true).length >= 1;
  const mainTitlePlaceHolders = [
    defaultWheelValue && defaultWheelValue.length > 0 && defaultWheelValue[0].value,
    checkObjectHasProperty(offerValues, 'currency'),
    checkObjectHasProperty(offerValues, 'giftValue'),
    checkObjectHasProperty(offerValues, 'giftUnit'),
    checkObjectHasProperty(offerValues, 'giftType'),
    checkObjectHasProperty(offerValues, 'giftOfferPrice'),
    checkObjectHasProperty(offerValues, 'currency'),
  ];
  const descriptionPlaceHolders = [
    checkObjectHasProperty(offerValues, 'giftNormalPrice'),
    checkObjectHasProperty(offerValues, 'currency'),
    'Thursday',
  ];

  // to keep the code untouched we set if and take all the fields needed
  const topUp = (isDesktopWeb) ? {
    isTopUpSomeOne: true,
    accounts,
    handleOnPressRecipient,
    phoneNumberValidation,
    setIsValidTopupNumber,
    onContactListIconPress,
    setPhoneNo,
    isCustomAmount: false,
    ...getHeaderConfig(
      hasGiftValue && !QASubtitle,
      QASubtitle ||
      (hasGiftValue
        ? 'top_up_quick_action_offer_subtitle'
        : 'top_up_quick_action_subtitle'),
      null,
      mainTitlePlaceHolders,
      null,
      paymentDefaultTitleID,
      ''
    ),
    selectedTab,
    onSelectTabChange,
    currency,
    customAmount,
    onChangeCustomAmount,
    withCustomTabAmount,
    customAmountValidation,
    customAmountMaximum,
    wheelValues,
    onSelectWheelValue,
    defaultWheelValue,
    offerValues,
    singleValue,
    value,
    isBillingPayment,
    giftIcon,
    wheelSelector: true,
    wheelSelectorCurrencyAccessibilityLabel,
    wheelSelectorGiftIconAccessibilityLabel,
    wheelSelectorValueAccessibilityLabel,
    onSelectDefaultCard,
    selectedValue,
    isValidTopupNumber
  } :
    {
      isTopUpSomeOne: true,
      accounts,
      handleOnPressRecipient,
      phoneNumberValidation,
      setIsValidTopupNumber,
      onContactListIconPress,
      setPhoneNo,
    }

  const defaultProps = (isDesktopWeb) ? {
    accounts,
    handleOnPressRecipient,
    phoneNumberValidation,
    setIsValidTopupNumber,
    onContactListIconPress,
    setPhoneNo,
    isCustomAmount: false,
    ...getHeaderConfig(
      hasGiftValue && !QASubtitle,
      QASubtitle ||
      (hasGiftValue
        ? 'top_up_quick_action_offer_subtitle'
        : 'top_up_quick_action_subtitle'),
      null,
      mainTitlePlaceHolders,
      null,
      paymentDefaultTitleID,
      ''
    ),
    selectedTab,
    onSelectTabChange,
    currency,
    customAmount,
    onChangeCustomAmount,
    customAmountValidation,
    customAmountMaximum,
    wheelValues,
    onSelectWheelValue,
    defaultWheelValue,
    offerValues,
    singleValue,
    value,
    isBillingPayment,
    giftIcon,
    wheelSelector: true,
    wheelSelectorCurrencyAccessibilityLabel,
    wheelSelectorGiftIconAccessibilityLabel,
    wheelSelectorValueAccessibilityLabel,
    onSelectDefaultCard,
    selectedValue,
    isValidTopupNumber: true,
    isBalanceTopUp: isBillingPayment ? false : true,
    withCustomTabAmount,
  } : {
    onSelectWheelValue,
    defaultWheelValue,
    wheelValues,
    offerValues,
    singleValue,
    value,
    isBillingPayment,
    currency,
    giftIcon,
    wheelSelector: true,
    wheelSelectorCurrencyAccessibilityLabel,
    wheelSelectorGiftIconAccessibilityLabel,
    wheelSelectorValueAccessibilityLabel,
    onSelectDefaultCard,
    ...getHeaderConfig(
      hasGiftValue && !QASubtitle,
      QASubtitle ||
      (hasGiftValue
        ? 'top_up_quick_action_offer_subtitle'
        : 'top_up_quick_action_subtitle'),
      null,
      mainTitlePlaceHolders,
      null,
      paymentDefaultTitleID,
      ''
    ),
    selectedTab,
    onSelectTabChange,
    withCustomTabAmount
  }

  return {
    [DEFAULT]: defaultProps,
    [OFFERGIFT]: {
      isReward: true,
      selectedValue,
      offerValues,
      onAddOffer,
      offerGiftIconID,
      offerGiftTitleID,
      offerGiftSubtitleID,
      newBalance,
    },
    [PAYMENTREQUEST]: {
      isPaymentRequest: true,
      singleValue: undefined,
      ...getCenterViewConfig(
        null,
        isBillingPayment
          ? 'payment_quick_action_loading'
          : isAddDataWithGift
            ? 'top_up_quick_action_loading_main'
            : 'top_up_quick_action_loading_purchase',
        'spinner',
        paymentRequestIconID,
        '',
        paymentRequestSubtitleID,
      ),
    },
    [SETUP_AUTO_BILL]: {
      isAutoBillSetup: true,
      onSelectBillDay,
      dateFilterBarTitle: 'auto_bill_date_filter_title',
      dateFilterBarDescription: 'auto_bill_date_filter_description',
      dateFilterBarSelectedDay: autoBillDay,
      dateFilterBarDaysCount: autoBillDayLimit || 31,
    },
    [SETUP_AUTO_BILL_LOADING]: {
      isPaymentRequest: true,
      ...getCenterViewConfig(
        null,
        isSetupAutoBill ? 'auto_bill_quick_action_loading' : 'auto_bill_quick_action_edit_loading',
        'spinner',
        paymentRequestIconID,
        '',
        paymentRequestSubtitleID,
      ),
    },
    [SETUP_AUTO_BILL_SUCCESS]: {
      isTick: true,
      ...getCenterViewConfig(
        'auto_bill_quick_action_successful_title',
        'auto_bill_quick_action_successful_description',
        'tick',
        paymentSuccessfullyIconID,
        paymentSuccessfullyTitleID,
        paymentSuccessfullySubtitleID,
        null,
        [autoBillDay, autoBillMonth],
      ),
    },
    [SETUP_AUTO_BILL_ERROR]: {
      isPaymentFailed: true,
      title: error.name,
      subTitle: error.message,
      sourceImage: error.icon || Images.ic_WarningHiLight_Theme,
    },
    [SETUP_AUTO_TOP_UP]: {
      isAutoTopUpSetup: true,
      autoTopUpData: autoTopUpData,
      onSelectAutoTopUpData,
      currency: '€',
      occurrenceSelectionTitle: 'auto_top_up_quick_action_subtitle',
      occurrenceSelectionOptions: [
        {
          type: 'weekly',
          name: 'auto_top_up_weekly_text',
          title: 'auto_top_up_weekly_subtitle',
          description: 'auto_top_up_weekly_description',
          options: [
            'auto_top_up_days_list_monday',
            'auto_top_up_days_list_tuesday',
            'auto_top_up_days_list_wednesday',
            'auto_top_up_days_list_thursday',
            'auto_top_up_days_list_friday',
            'auto_top_up_days_list_saturday',
            'auto_top_up_days_list_sunday',
          ],
        },
        {
          type: 'monthly',
          name: 'auto_top_up_monthly_text',
          title: 'auto_top_up_monthly_subtitle',
          description: 'auto_top_up_monthly_description',
          options: _map(Array(autoTopUpMonthDaysLimit), (_, i) =>
            i < 9 ? `0${i + 1}` : `${i + 1}`,
          ),
        },
        {
          type: 'amount',
          name: 'auto_top_up_amount_text',
          title: 'auto_top_up_amount_subtitle',
          description: 'auto_top_up_amount_description',
          options: autoTopUpLessThanAmounts || [1, 2, 3, 4, 5, 10, 15],
        },
      ],
    },
    [SETUP_AUTO_TOP_UP_LOADING]: {
      isPaymentRequest: true,
      ...getCenterViewConfig(
        null,
        isSetupAutoTopUp
          ? 'auto_top_up_quick_action_loading'
          : 'auto_top_up_quick_action_edit_loading',
        'spinner',
        paymentRequestIconID,
        '',
        paymentRequestSubtitleID,
      ),
    },
    [SETUP_AUTO_TOP_UP_SUCCESS]: {
      isTick: true,
      ...getCenterViewConfig(
        'auto_top_up_quick_action_success_title',
        autoTopUpData?.occurrence === 'weekly'
          ? 'auto_top_up_quick_action_success_weekly_description'
          : autoTopUpData?.occurrence === 'monthly'
            ? 'auto_top_up_quick_action_success_monthly_description'
            : 'auto_top_up_quick_action_success_amount_description',
        'tick',
        paymentSuccessfullyIconID,
        paymentSuccessfullyTitleID,
        paymentSuccessfullySubtitleID,
        null,
        autoTopUpSuccessPlaceholders,
      ),
    },
    [SETUP_AUTO_TOP_UP_ERROR]: {
      isPaymentFailed: true,
      title: error.name,
      subTitle: error.message,
      sourceImage: error.icon || Images.ic_WarningHiLight_Theme,
    },
    [TOP_UP_SOMEONE_ELSE]: topUp,
    [TOP_UP_SOMEONE_ELSE_LOADING]: {
      isPaymentRequest: true,
      ...getCenterViewConfig(
        null,
        'top_up_quick_action_loading_main',
        'spinner',
        paymentRequestIconID,
        '',
        paymentRequestSubtitleID,
      ),
    },
    [TOP_UP_SOMEONE_ELSE_SUCCESS]: {
      isTick: true,
      ...getCenterViewConfig(
        'top_up_someone_else_successful_title',
        'top_up_someone_else_successful_description',
        'tick',
        paymentSuccessfullyIconID,
        paymentSuccessfullyTitleID,
        paymentSuccessfullySubtitleID,
        null,
        [newBalance && newBalance?.balance, currency, phoneNo],
      ),
    },
    [TOP_UP_SOMEONE_ELSE_ERROR]: {
      isPaymentFailed: true,
      title: error.name,
      subTitle: error.message,
      sourceImage: error.icon || Images.ic_WarningHiLight_Theme,
    },
    [TOP_UP_SOMEONE_ELSE_CONTACT_LIST]: {
      isContactList: true,
      handleOnPressRecipient,
      recentContacts,
      ...getHeaderConfig(null, 'top_up_someone_else_contact_list_section_title'),
    },
    [DEFAULT_ERROR]: {
      isPaymentFailed: true,
      isLoadingError: true,
      subTitle: loadingError?.message,
      onTryAgainPress,
      sourceImage: error.icon || Images.ic_WarningHiLight_Theme,
    },
    [SUCCESSOFFERGIFT]: {
      isTick: true,
      ...getCenterViewConfig(
        'top_up_quick_action_successful',
        'top_up_quick_action_data_added_remaining',
        'tick',
        paymentSuccessfullyIconID,
        paymentSuccessfullyTitleID,
        paymentSuccessfullySubtitleID,
        null,
        [
          newExtraOffer && newExtraOffer.balance,
          currency,
          newExtraOffer && newExtraOffer?.remainingExtra,
          newExtraOffer && newExtraOffer?.unit,
        ],
      ),
    },
    [ADDDATAOFFER]: {
      giftIcon,
      upgradingPayment: true,
      ...getHeaderConfig(
        true,
        'add_data_buy_offer_confirmation_text',
        'top_up_quick_action_accepting_offer_subtitle',
        mainTitlePlaceHolders,
        descriptionPlaceHolders,
        paymentSuccessfullyTitleID,
        paymentSuccessfullySubtitleID,
      ),
    },
    [UPGRADETOOFFER]: {
      upgradingPayment: true,
      ...getHeaderConfig(
        false,
        'top_up_quick_action_offer',
        'top_up_quick_action_upgrade_top_up_subtitle',
        mainTitlePlaceHolders,
        descriptionPlaceHolders,
        upgradeOfferTitleID,
        upgradeOfferSubtitleID,
      ),
    },
    [PAYMENTSUCCESSFULLY]: {
      isTick: true,
      singleValue: undefined,
      ...getCenterViewConfig(
        isBillingPayment ? 'payment_quick_action_success' : 'top_up_quick_action_successful',
        isBillingPayment
          ? 'payment_quick_action_success_message'
          : selectedValue?.gift
            ? 'top_up_quick_action_balance_and_data_added_remaining'
            : 'top_up_quick_action_balance',
        'tick',
        paymentSuccessfullyIconID,
        paymentSuccessfullyTitleID,
        paymentSuccessfullySubtitleID,
        isBillingPayment ? billPaymentSuccessPlaceholders : null,
        isBillingPayment
          ? null
          : [newBalance && newBalance?.balance, currency, newBalance?.remainingExtra],
      ),
    },
    [PAYMENTFAILD]: {
      title: error.name,
      subTitle: error.message,
      sourceImage: error.icon || Images.ic_WarningHiLight_Theme,
      isPaymentFailed: true,
      singleValue: undefined,
    },
    [DATAADDED]: {
      isTick: true,
      ...getCenterViewConfig(
        'add_data_payment_success_title',
        'top_up_quick_action_data_added_remaining',
        'tick',
        paymentSuccessfullyIconID,
        paymentSuccessfullyTitleID,
        paymentSuccessfullySubtitleID,
        null,
        [newExtraOffer?.remainingExtra, newExtraOffer?.unit],
      ),
    },
    [ADD_PAYMENT_CARD_LOADING]: {
      isPaymentRequest: true,
      lottieID: paymentRequestIconID,
      subTitleID: paymentRequestSubtitleID,
      ...getCenterViewConfig(
        null,
        'top_up_quick_action_loading_main',
        'spinner',
        paymentRequestIconID,
        '',
        paymentRequestSubtitleID,
      ),
    },
    [ADD_PAYMENT_CARD]: {
      mainTitle: 'quick_action_add_new_payment_card_subtitle',
      cardNumberLabel: 'quick_action_add_new_payment_card_field_card_number',
      nameOnCardLabel: 'quick_action_add_new_payment_card_field_name_on_card',
      expirationDateLabel: 'quick_action_add_new_payment_card_field_expire_date',
      expirationDateFormatLabel: 'quick_action_add_new_payment_card_expiration_date_hint_message',
      cvvNumberLabel: 'quick_action_add_new_payment_card_field_cvv',
      cardNameLabel: 'quick_action_add_new_payment_card_field_card_name',
      saveCardText: 'quick_action_add_new_payment_card_save_this_card',
      secureText: 'quick_action_add_new_payment_card_encryption_hint',
      primaryButtonText: 'quick_action_add_new_payment_card_done',
      isSecureIcon: false,
      isSecureContainerBottomBorder: true,
      onPressSaveCard: onPressSaveCard,
      hiddenFields: hiddenFields,
      cardData: cardData,
      validations: validations,
      saveForLaterIntialValue,
      shouldShowTempCardName,
      isAddingPaymentCard: true,
      hideSaveCardForLater,
    },
    [CUSTOM_AMOUNT]: {
      isCustomAmount: true,
      ...getHeaderConfig(
        hasGiftValue && !QASubtitle,
        QASubtitle ||
        (hasGiftValue ? 'top_up_quick_action_offer_subtitle' : 'top_up_quick_action_subtitle'),
        null,
        mainTitlePlaceHolders,
        null,
        paymentDefaultTitleID,
        '',
      ),
      selectedTab,
      onSelectTabChange,
      currency,
      customAmount,
      onChangeCustomAmount,
      withCustomTabAmount,
      customAmountValidation,
      customAmountMaximum,
    },
    [VOUCHER_INTIIAL_STATE]: {
      isVoucherTopUp,
    },
    [VOUVHER_TOP_UP_LOADING]: {
      isVoucherTopUpContainer: true,
      isPaymentRequest: true,
      ...getCenterViewConfig(
        null,
        'voucher_top_up_loading_text',
        'spinner',
        paymentRequestIconID,
        '',
        paymentRequestSubtitleID,
      ),
    },
    [VOUCHER_TOP_UP_SUCCESS]: {
      isVoucherTopUpContainer: true,
      isTick: true,
      ...getCenterViewConfig(
        'voucher_top_up_success_screen_title',
        'voucher_top_up_success_screen_subtitle',
        'tick',
        paymentSuccessfullyIconID,
        paymentSuccessfullyTitleID,
        paymentSuccessfullySubtitleID,
        null,
        [voucherAmount],
      ),
    },
    [VOUCHER_TOP_UP_ERROR]: {
      isVoucherTopUpContainer: true,
      isPaymentFailed: true,
      title: error.name,
      subTitle: error.message,
      sourceImage: error.icon || Images.ic_WarningHiLight_Theme,
    },
  };
};

export default memoize(getPaymentBodyConfig);
